import { customElement, bindable, autoinject, bindingMode } from 'aurelia-framework';
import { BusyService } from '../../services/busy-service';
import { WebApiService } from '../../services/web-api-service';
import { DialogService } from 'aurelia-dialog';
import { UploadDocumentDialog } from '../dialogs/upload-document-dialog';
import { CarrierDocument } from '../../models/carrier-document';

@autoinject()
export class DocumentThumbnail {

    constructor(private dialogService: DialogService, private element:Element) {
    }

    @bindable() document: CarrierDocument;
    @bindable() selected: boolean;


    attached() {
    }

    detached() {
    }

    upload() {
        this.fireDocumentRefreshEvent("upload");
    }

    deleteDocument() {
        this.fireDocumentRefreshEvent("delete");
    }

    fireDocumentRefreshEvent(event: string) {
        let evt;

        if (window["CustomEvent"]) {
            evt = new CustomEvent('action', {
                detail: {
                    //value: (<any>event.target).value
                    value: event
                },
                bubbles: true
            });
        } else {
            evt = document.createEvent('CustomEvent');
            evt.initCustomEvent('action', true, true, {
                detail: {
                    //value: (<any>event.target).value
                    value: event
                }
            });
        }
        (<any>this.element).dispatchEvent(evt);
    }

}